export default "/_next/static/images/triangle-406e8eed74974c596efeab4f1f5dfed7.svg";